import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
// Create the tRPC React Query hooks
export const trpc = createTRPCReact();
// Create vanilla tRPC client (if needed outside of React)
export const trpcClient = createTRPCClient({
    links: [
        httpBatchLink({
            url: import.meta.env.DEV ? 'http://localhost:8787/trpc' : '/trpc',
            headers() {
                const token = localStorage.getItem('sessionToken');
                return token ? { Authorization: `Bearer ${token}` } : {};
            },
        }),
    ],
});
